import { Injectable } from '@angular/core';

import * as _moment from 'moment-timezone';

import { TIME_TRANSLATIONS, TranslationsProvider } from '@recruitee/i18n';

const moment = _moment;

@Injectable({ providedIn: 'root' })
export class TimeAgoBase {
  protected locales: string[] = this.translationsProvider.availableLocales;
  protected defaultLocale: string = this.translationsProvider.defaultLocale;
  protected translations: Record<string, [string, string][]> = TIME_TRANSLATIONS;

  constructor(private translationsProvider: TranslationsProvider) {}

  public getTime(value: _moment.MomentInput, omitSuffix: boolean): string {
    const timeAgo = moment(value).fromNow(omitSuffix);

    return omitSuffix ? this.stringReplace(timeAgo) : timeAgo;
  }

  private getCurrentLang(): string {
    const momentLang = 'fi';

    if (this.locales.includes(momentLang)) {
      return momentLang;
    } else {
      return this.defaultLocale;
    }
  }

  private stringReplace(timeAgo: string): string {
    let time = '';
    const currentLang = this.getCurrentLang();

    this.translations[currentLang].forEach(pair => {
      if (timeAgo.toLowerCase().indexOf(pair[0].toLowerCase()) !== -1) {
        time = timeAgo.replace(pair[0], pair[1]);
      }
    });

    return time;
  }
}
